import request from '@/utils/request';
import { async } from 'q';
import { loginOrg, loginUser,loginCompany } from '@/utils/LoginContext';
export async function query(payload) {
  return request(`/iwms-wms/wms/picktask/page`,{
    method: 'POST',
    body: payload,
  });
}
export async function abort(payload) {
  return request(`/iwms-wms/wms/picktask/${payload.uuid}/abort`, {
    method: 'POST'
  });
}

export async function audit(payload) {
  return request(`/iwms-wms/wms/picktask/audit`, {
    method: 'POST',
    body: payload
  });
}

export async function get(payload) {
  return request(`/iwms-wms/wms/picktask/${payload.uuid}`);
}

export async function getByNumber(payload) {
  return request(`/iwms-wms/wms/picktask/${payload.taskNumber}/get?dcUuid=${payload.dcUuid}`);
}

export async function generate(payload) {
  return request(`/iwms-wms/wms/picktask/generate/${payload.uuid}`, {
    method: 'POST',
    body: payload.requests
  });
}

export async function getSchedule(payload) {
  return request(`/iwms-wms/wms/picktask/${payload.uuid}/schedule`);
}

export async function getByPsTaskUuid(payload){
  return request(`/iwms-wms/wms/picktask/getByPsTaskUuid?psTaskUuid=${payload.psTaskUuid}`);
}

export async function queryPickingTasks(payload) {
  return request(`/iwms-wms/wms/picktask/queryPickingTasks`,{
    method: 'POST',
    body: payload,
  });
}

export async function querySowingTasks(payload) {
  return request(`/iwms-wms/wms/picktask/querySowingTasks`,{
    method: 'POST',
    body: payload,
  });
}

export async function sowRestStockShift(payload) {
  return request(`/iwms-wms/wms/picktask/sowRestStockShift?taskNumber=${payload.taskNumber}&dcUuid=${loginOrg().uuid}&targetBinCode=${payload.targetBinCode}`,{
    method: 'POST',
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/picktask/${payload.uuid}/modifyrealqty?realQty=${payload.realQty}&realQtyStr=${payload.realQtyStr}`,{
    method: 'POST',
  });
}

export async function batchModifyrealqty(payload){
  return request(`/iwms-wms/wms/picktask/batchModifyrealqty`,{
    method: 'POST',
    body:payload
  })
}

export async function batchimport(payload){
  return request(`/iwms-wms/wms/picktask/batchimport?companyUuid=${loginCompany().uuid}&dcUuid=${loginOrg().uuid}&fileKey=${payload.fileKey}`,{
      method:'POST',
      body:payload 
  })
}
